import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { viewContactUsList } from "../../Redux/Actions/contactUsAction";
import "./listContactUs.css";
import toast from "react-hot-toast";
import { columnsContactUs } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListContactUs = () => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback(
        async (page, pageSize, showLoader = true) => {
            const payload = {
                page,
                limit: pageSize,
                filter: debouncedSearch,
                ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
                ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
            };
            try {
                await dispatch(viewContactUsList(payload, showLoader));
                if (!showLoader) toast.success("List refreshed");
            } catch {
                if (!showLoader) toast.error("Failed to refresh list");
            }
        },
        [dispatch, debouncedSearch, dateRange]
    );

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [fetchDetails, pagination.current, pagination.pageSize]);

    const { contactUsList, loading } = useSelector((state) => state.contactUs || {});

    useEffect(() => {
        if (contactUsList?.total) {
            setPagination((prev) => ({ ...prev, total: contactUsList.total }));
        }
    }, [contactUsList]);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedSearch(searchQuery), 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (pagination) => setPagination(pagination);

    const handleDateRangeApply = (start, end) => {
        setDateRange(
            start === null && end === null ? { start: null, end: null } : { start, end }
        );
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    return (
        <MainLayout>
            <div className="lcu-container">
                <div className="lcu-table-wrap">
                    <ListTopSearch
                        h3heading="Contact Us List"
                        setState={setSearchQuery}
                        onCalendarClick={() => setIsDatePopupVisible(true)}
                    />
                    <div style={{ overflowX: "auto", padding: "0px 60px" }}>
                        <Table
                            dataSource={Array.isArray(contactUsList?.data) ? contactUsList.data : []}
                            pagination={pagination}
                            scroll={{ x: 1000, y: 500 }}
                            onChange={handleTableChange}
                            loading={loading}
                            columns={columnsContactUs}
                            rowKey="_id"
                            rowClassName={() => "text-center"}
                        />
                    </div>
                </div>
                <DateRangePopup
                    visible={isDatePopupVisible}
                    initialStart={dateRange.start}
                    initialEnd={dateRange.end}
                    onCancel={() => setIsDatePopupVisible(false)}
                    onOk={handleDateRangeApply}
                />
            </div>
        </MainLayout>
    );
};

export default ListContactUs;